import styles from "./styles/subscription-card.module.scss";
import SubscriptionFeature from "@/components/pages/pricing-a/components/subscription-feature";
import UpgradeSubscriptionButton from "@/components/pages/pricing-a/components/upgrade-subscription-button";
import { SubscriptionInfo } from "@/data/license.data";
import React from "react";
import SubscriptionPriceBlock from "@/components/pages/pricing-a/components/subscription-price-block";
import { pluralize } from "@/utils/text";

interface SubscriptionCardProps {
  subscriptionInfo: SubscriptionInfo;
  coupon: string | null;
  couponSalePercent: number | null;
  isYearly: boolean;
  onUpgradeClick?: (
    isYearly: boolean,
    subscriptionInfo: SubscriptionInfo,
  ) => void;
}

const SubscriptionCard = ({
  subscriptionInfo,
  coupon,
  couponSalePercent,
  isYearly,
  onUpgradeClick,
}: SubscriptionCardProps) => {
  const couponUrlParam =
    !isYearly && coupon ? `&coupon-code-to-add=${coupon}` : "";

  const getFormatedPrice = (): string | null => {
    if (isYearly) {
      const yearlyPrice = subscriptionInfo.price * 0.6;
      const roundedYearlyPrice = Math.round(yearlyPrice * 10) / 10;
      return roundedYearlyPrice % 1 === 0
        ? roundedYearlyPrice.toFixed(0)
        : roundedYearlyPrice.toFixed(1);
    }

    if (couponSalePercent) {
      const salePrice = (subscriptionInfo.price / 100) * couponSalePercent;
      const roundedPrice = subscriptionInfo.price - salePrice;
      return roundedPrice % 1 === 0
        ? roundedPrice.toFixed(0)
        : roundedPrice.toFixed(1);
    }

    return null;
  };

  const isMostPopular = subscriptionInfo.title === "Creator";
  const formattedPrice = getFormatedPrice();

  return (
    <div
      className={styles.subscription_card}
      style={{
        borderColor: isMostPopular ? "#FF5722" : "#3f3f3f",
      }}
    >
      <div className={styles.subscription_info_wrapper}>
        <div className={styles.subscription_title}>
          {subscriptionInfo.title}
        </div>
        {/*<div className={styles.custom_voices_count}>*/}
        {/*  {subscriptionInfo.customVoicesCount} Custom{" "}*/}
        {/*  {pluralize("Voice", subscriptionInfo.customVoicesCount)}*/}
        {/*</div>*/}
        {isMostPopular && <div className={styles.recommended}>RECOMMENDED</div>}
      </div>
      <SubscriptionPriceBlock
        subscriptionInfo={subscriptionInfo}
        formattedPrice={formattedPrice}
      />
      <UpgradeSubscriptionButton
        productId={
          isYearly
            ? subscriptionInfo.yearlyProductId
            : subscriptionInfo.productId
        }
        isMostPopularSubscription={isMostPopular}
        couponUrlParam={couponUrlParam}
        onClick={
          onUpgradeClick
            ? () => onUpgradeClick(isYearly, subscriptionInfo)
            : () => {}
        }
      />

      <div className={styles.features_wrapper}>
        <div className={styles.features_header}>Features</div>
        <div className={styles.separator} />
        {/*<SubscriptionFeature*/}
        {/*  feature={`${subscriptionInfo.customVoicesCount} custom voice ${pluralize("slot", subscriptionInfo.customVoicesCount)} and blended ${pluralize("voice", subscriptionInfo.customVoicesCount)}`}*/}
        {/*/>*/}
        {/*<SubscriptionFeature*/}
        {/*  feature={`${subscriptionInfo.convertsCount} song creations${isNaN(Number(subscriptionInfo.convertsCount)) ? "" : "/month"}`}*/}
        {/*/>*/}
        <SubscriptionFeature feature={`${subscriptionInfo.speed} speed`} />
        <SubscriptionFeature
          feature={`${subscriptionInfo.soundQuality} sound`}
        />
        {subscriptionInfo.features.map((feature, index) => (
          <SubscriptionFeature key={index} feature={feature} />
        ))}
        {subscriptionInfo.textToMusic && (
          <SubscriptionFeature feature={`Text to music access`} />
        )}
      </div>
    </div>
  );
};

export default SubscriptionCard;
